import { useEffect } from 'react';
import { useUiStore, resolveIsDark } from '@shared/stores/uiStore';

/**
 * Uygulamada her zaman aktif klavye kısayolları:
 *   ⌘K / Ctrl+K           → komut paleti
 *   ⌘/ / Ctrl+/           → klavye kısayol sayfası
 *   ⇧⌘L / Ctrl+Shift+L    → tema toggle
 *   Esc                   → açık modal/drawer kapat
 */
export function useGlobalShortcuts() {
  const toggleCommandPalette = useUiStore((s) => s.toggleCommandPalette);
  const setCommandPaletteOpen = useUiStore((s) => s.setCommandPaletteOpen);
  const setShortcutSheetOpen = useUiStore((s) => s.setShortcutSheetOpen);
  const colorScheme = useUiStore((s) => s.colorScheme);
  const setColorScheme = useUiStore((s) => s.setColorScheme);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const mod = e.metaKey || e.ctrlKey;
      if (mod && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        toggleCommandPalette();
        return;
      }
      if (mod && e.key === '/') {
        e.preventDefault();
        setShortcutSheetOpen(true);
        return;
      }
      if (mod && e.shiftKey && e.key.toLowerCase() === 'l') {
        e.preventDefault();
        setColorScheme(resolveIsDark(colorScheme) ? 'light' : 'dark');
        return;
      }
      if (e.key === 'Escape') {
        setCommandPaletteOpen(false);
        setShortcutSheetOpen(false);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [
    toggleCommandPalette,
    setCommandPaletteOpen,
    setShortcutSheetOpen,
    colorScheme,
    setColorScheme,
  ]);
}
